var map = {
	"./account.svg": 118,
	"./addFile.svg": 123,
	"./calendar.svg": 119,
	"./covid.svg": 139,
	"./female.svg": 371,
	"./info.svg": 163,
	"./menu.svg": 137,
	"./notification.svg": 136,
	"./tube.svg": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;